import {
    Autocomplete,
    Button,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { PosContext } from "../../../../shared/PosContext";
import { useCreateDoctypeData } from "../../../../shared/hooks/useDocTypesData";
import { useStyles } from "./styles";

const NewAddress = ({ customerName, onClose, onCreate }) => {
    const classes = useStyles();
    const isMutating = useIsMutating();
    const { territoryOptions, refetchAddresses } = useContext(PosContext);

    const [loading, setLoading] = useState(false);

    const createAddressMutation = useCreateDoctypeData();

    useEffect(() => {
        if (isMutating) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [isMutating]);

    const [formData, setFormData] = useState({
        address_line1: "",
        address_line2: "",
        territory: "",
    });

    const requiredFields = ["territory", "address_line1"];
    const formDefaults = {
        docstatus: 1,
        doctype: "Address",
        name: "new-address-1",
        address_type: "Billing",
        city: "رامالله",
        links: [
            {
                docstatus: 1,
                doctype: "Dynamic+Link",
                name: "new-dynamic-link-1",
                parent: "new-address-1",
                parentfield: "links",
                parenttype: "Address",
                idx: 1,
                link_doctype: "Customer",
                link_name: customerName,
            },
        ],
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleReset = () => {
        setFormData({
            address_line1: "",
            address_line2: "",
            territory: "",
        });
    };

    const handleSubmit = () => {
        let requiredField = null;

        requiredFields.forEach((field) => {
            if (!requiredField && formData[field] === "") {
                requiredField = field;
                return;
            }
        });

        if (requiredField) {
            enqueueSnackbar(`${requiredField} is required !`);
            return;
        }

        createAddressMutation.mutate(
            {
                doctype: "Address",
                formData: { ...formDefaults, ...formData },
            },
            {
                onSuccess: (data) => {
                    refetchAddresses();
                    onCreate?.(data?.data);
                },
            }
        );
    };

    return (
        <div className={classes.NewAddressWrapper}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <Autocomplete
                        value={formData.territory}
                        onChange={(e, val) => {
                            setFormData({ ...formData, ["territory"]: val });
                        }}
                        options={territoryOptions}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                            <TextField
                                required
                                {...params}
                                label={"Territory"}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        required
                        name="address_line1"
                        label="Address"
                        value={formData.address_line1}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        name="address_line2"
                        label="Address details"
                        value={formData.address_line2}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <div className={classes.ActionsFooter}>
                <Button disabled={loading} onClick={() => handleReset()}>
                    Reset
                </Button>
                <Button
                    disabled={loading}
                    variant="contained"
                    onClick={() => handleSubmit()}
                >
                    {loading && (
                        <CircularProgress
                            size={17}
                            style={{ color: "white", marginRight: "5px" }}
                        />
                    )}
                    Submit
                </Button>
            </div>
        </div>
    );
};

export default NewAddress;
